module.exports = __webpack_public_path__ + "img/top-section-mobile.a9a1b901.png";